<template>
  <LayoutModal ref="modal">
    <h3 class="mb-2">Choisir un équipement :</h3>
    <CommonAccordion
      v-for="node in organization_unit_store.root?.childrens"
      :node="node"
      v-bind:key="node.id"
      @select="select_device"
    />
  </LayoutModal>
</template>

<script setup lang="ts">
import CommonAccordion from '@/components/common/CommonAccordion.vue'
import LayoutModal from '@/components/layout/LayoutModal.vue'
import { useOrganizationUnitStore } from '@/stores/store_organization_unit'
import type { components } from '@/types/gateway_schema'
import { ref } from 'vue'

const modal = ref<InstanceType<typeof LayoutModal>>()
const organization_unit_store = useOrganizationUnitStore()

function select_device(device: components['schemas']['SopravisionDeviceDTO']) {
  emits('select', device)
  modal.value?.close()
}

function open() {
  modal.value?.open()
}

defineExpose({ open })

const emits = defineEmits<{
  (e: 'select', value: components['schemas']['SopravisionDeviceDTO']): void
}>()
</script>
